import { SparklesIcon } from "@heroicons/react/24/solid";
import { ReactNode } from "react";

interface BetaBannerProps {
    children: ReactNode;
}

export const BetaBanner: React.FC<BetaBannerProps> = ({ children }) => {
    return (
        <div className="rounded-md px-4 gap-x-2 grow flex items-center justify-between w-full bg-gradient-to-r from-[#cce0ff] to-[#d9fff6] p-4">
            <div className="flex items-center gap-x-4 flex-1 min-w-0">
                <SparklesIcon
                    className="h-5 w-5 flex-shrink-0 text-blue-500 animate-pulse"
                    aria-hidden="true"
                />
                <div className="text-sm text-blue-900 flex-1 min-w-0">{children}</div>
            </div>
            <span className="inline-flex items-center px-2 py-1 text-xs font-bold text-white bg-blue-800 rounded-md">
                Beta
            </span>
        </div>
    );
};
